import { render } from "./coursewareAdd.vue?vue&type=template&id=8c6d2974&scoped=true"
import script from "./coursewareAdd.vue?vue&type=script&lang=js"
export * from "./coursewareAdd.vue?vue&type=script&lang=js"

import "./coursewareAdd.vue?vue&type=style&index=0&id=8c6d2974&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6d2974"]])

export default __exports__